<template>
    <div class="conList">
        <div class="item"><p>{{$t("trade.products.tradeProduct")}}</p><p>{{$t("trade.products.ask")}}</p><p>{{$t("trade.products.bid")}}</p></div>
        <ul v-if="tickList&&tickList.length>0">
            <li v-for="(data,index) in tickList" @click="goQuoteChart(data.uiCodeID,index)">
                <span>{{data.symbol}}</span>
                <span :class="isSell(data)">{{data.ask}}</span>
                <span :class="isBuy(data)">{{data.bid}}</span>
            </li>
        </ul>
        <InternetSpeed v-else></InternetSpeed>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import InternetSpeed from '@/view/module/InternetSpeed.vue'
    export default {
        name: "Quote",
        components:{InternetSpeed},
        props:["tickList"],
        methods:{
            goQuoteChart(id,index){
                this.$bus.$emit('loading', false);
                this.$router.push({path: '/home/quoteChart',query: {id: id,index:index}});
            },
            isSell: function (obj) {
                let val;
                if (obj.preData) {
                    if (Number(obj.ask) > Number(obj.preData.ask)) {
                        val = "rise"
                    } else if (Number(obj.ask) < Number(obj.preData.ask)) {
                        val = "fall"
                    } else {
                        val = "level"
                    }
                } else {
                    if (Number(obj.ask) > Number(obj.preclose)) {
                        val = "rise"
                    } else if (Number(obj.ask) < Number(obj.preclose)) {
                        val = "fall"
                    } else {
                        val = "level"
                    }
                }
                return val;
            },
            isBuy: function (obj) {
                let val;
                if (obj.preData) {
                    if (Number(obj.bid) > Number(obj.preData.bid)) {
                        val = "rise"
                    } else if (Number(obj.bid) < Number(obj.preData.bid)) {
                        val = "fall"
                    } else {
                        val = "level"
                    }
                } else {
                    if (Number(obj.bid) > Number(obj.preclose)) {
                        val = "rise"
                    } else if (Number(obj.bid) < Number(obj.preclose)) {
                        val = "fall"
                    } else {
                        val = "level"
                    }
                }
                return val;
            },
        },
    }
</script>
